import React from "react";
import PageBanner from "./PageBanner";
import { Link } from "react-router-dom";
import "./ServicePage.css";

const ServicePage = ({
  title,
  breadcrumb,
  bgImage,
  heroImg,
  sectionTitle,
  description,
  overviewItems,
  featureItems,
  faqList,
  sideImage1,
  sideImage2,
  ctaBg,
  phoneNumber,
}) => {
  return (
    <div>
      <PageBanner title={title} breadcrumb={breadcrumb} bgImage={bgImage} />

      <section className="service-page-wrapper py-5">
        <div className="container">
          <div className="row">
            {/* LEFT */}
            <div className="col-lg-8 service-left-wrapper">
              <div className="service-left-inner">
                {/* Hero Image */}
                <div className="service-image-box mb-4">
                  <img src={heroImg} alt={title} className="service-hero-img" />
                </div>

                <h2 className="service-left-title">{sectionTitle}</h2>

                <p className="service-left-description">{description}</p>

                {/* Overview */}
                <div className="service-overview-box mt-5">
                  <h4 className="service-overview-title">Service Overview</h4>
                  <div className="row g-3">
                    {overviewItems.map((item, idx) => (
                      <div className="col-md-6" key={idx}>
                        <div className="service-overview-item border p-3 rounded d-flex align-items-start gap-2">
                          <i
                            className="bi bi-check2-all text-primary mt-1"
                            aria-hidden="true"
                          ></i>
                          {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Images */}
                <div className="service-images-wrapper row mt-5">
                  <div className="col-md-6">
                    <div className="service-image-container">
                      <img
                        src={sideImage1}
                        alt="Visual One"
                        className="service-side-img"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="service-image-container">
                      <img
                        src={sideImage2}
                        alt="Visual Two"
                        className="service-side-img"
                      />
                    </div>
                  </div>
                </div>

                <div className="service-features-box mt-5">
                  <h4 className="service-features-title">Key Features</h4>
                  <div className="row g-3">
                    {featureItems.map((feature, idx) => (
                      <div className="col-md-4" key={idx}>
                        <div className="feature-box p-3 rounded text-left">
                          <i className={`bi ${feature.icon} fs-2 mb-2`}></i>
                          <h6>{feature.title}</h6>
                          <p>{feature.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* FAQs */}
                <div className="service-faqs py-5">
                  <h4 className="service-faqs-title mb-4">General Questions</h4>
                  <div className="accordion" id="faqAccordion">
                    {faqList.map(({ id, question, answer }) => (
                      <div className="accordion-item service-faq-item" key={id}>
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#faqCollapse${id}`}
                            aria-expanded="false"
                            aria-controls={`faqCollapse${id}`}
                          >
                            <span className="question-text">{question}</span>
                            <i className="bi bi-arrow-right ms-auto arrow-icon"></i>
                          </button>
                        </h2>
                        <div
                          id={`faqCollapse${id}`}
                          className="accordion-collapse collapse"
                          data-bs-parent="#faqAccordion"
                        >
                          <div className="accordion-body service-faq-body">
                            {answer}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDEBAR */}
            <div className="col-lg-4">
              <div className="services-sidebar p-4 rounded-4 bg-light">
                <h5 className="fw-bold mb-3">Our Services</h5>
                <ul className="list-unstyled d-flex flex-column gap-2">
                  {["Accounting", "Consulting", "Grants", "Taxes"].map(
                    (svc) => (
                      <li key={svc}>
                        <Link
                          to={`/${svc.toLowerCase()}`}
                          className="service-box"
                        >
                          {svc}
                        </Link>
                      </li>
                    )
                  )}
                </ul>
              </div>

              {/* CTA */}
              <div
                className="service-cta-box position-relative text-white rounded p-4 service-widget-cta"
                style={{
                  backgroundImage: `url(${ctaBg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="overlay"></div>
                <div className="cta-content position-relative p-4 rounded text-white">
                  <h6 className="fw-bold">Need Help?</h6>
                  <p className="fs-5 fw-bold">{phoneNumber}</p>
                  {/* <small className="d-block mb-3">Mon - Fri: 9am - 6pm</small> */}
                  <a
                    href={`https://wa.me/${phoneNumber.replace(/[^0-9]/g, "")}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="btn btn-light fw-bold px-4 py-2">
                      CALL US TO BOOK AN APPOINTMENT
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicePage;
